import confetti from "canvas-confetti"

export function showConfetti(colors) {
    colors = colors || ["#fff", "f00"]
    const end = Date.now() + 5 * 1000
    let count = 0

    ;(function frame() {
        const color = colors[count++ % colors.length]

        confetti({
            particleCount: 2,
            angle: 60,
            spread: 100,
            origin: { x: 0, y: 0.4 },
            colors: [color],
        })

        confetti({
            particleCount: 2,
            angle: 90,
            spread: 100,
            origin: { x: 0.5, y: 0.4 },
            colors: [color],
        })

        confetti({
            particleCount: 2,
            angle: 120,
            spread: 100,
            origin: { x: 1, y: 0.4 },
            colors: [color],
        })

        if (Date.now() < end) {
            window.requestAnimationFrame(frame)
        }
    })()
}
